// HP-60: the environment (Prod, UAT, SIT) as a badge next to the product's name.
import { ENVIRONMENTS, environmentOf } from './environment'

export default function EnvironmentBadge({ env = environmentOf() }) {
  const { label, className } = ENVIRONMENTS[env]
  return (
    <span
      data-testid="environment-badge"
      className={`inline-flex flex-shrink-0 items-center rounded px-1.5 py-0.5 text-xs font-semibold leading-none ${className}`}
    >
      {label}
    </span>
  )
}
